import { HTMLAttributes, ReactNode, TdHTMLAttributes } from 'react'

export type ListRowCell = Omit<
  TdHTMLAttributes<HTMLTableCellElement>,
  'content'
> & {
  key: string
  content: ReactNode
}

type ListRowProps = HTMLAttributes<HTMLTableRowElement> & {
  cells: ListRowCell[]
  actions?: ReactNode
  actionsClassName?: string
}

export const ListRow = ({
  cells,
  actions,
  actionsClassName = '',
  className = '',
  onClick,
  ...props
}: ListRowProps) => {
  const clickableClassName = onClick ? 'list-item-row-clickable' : ''

  return (
  <tr
    className={`list-item-row ${clickableClassName} ${className}`.trim()}
    onClick={onClick}
    {...props}
  >
    {cells.map(({ key, content, className: cellClassName = '', ...cell }) => (
      <td key={key} className={cellClassName} {...cell}>
        {content}
      </td>
    ))}

    {actions !== undefined && (
      <td className={`list-item-row-actions ${actionsClassName}`}>
        {actions}
      </td>
    )}
  </tr>
  )
}
